import React from 'react';
import { ModalProps } from '../../../../components/Modal';
import ContainerModal from '../../../../components/ContainerModal';

import { ReactComponent as CallCenterIcon } from '../../../../assets/call-center-rounded.svg';
import { ReactComponent as CalendarIcon } from '../../../../assets/calendar-rounded.svg';

import * as S from './styles';
import { Button } from '../../../../components';
import { WhatsappWhiteSM } from '../../../../components/Icons';
import WarningIcon from '../../../../components/WarningIcon';

const infos = [
  {
    icon: <CallCenterIcon />,
    text: '<p>Entre em contato conosco ligando no número <a href="tel:+551121511233" style="color: #004F92; font-weight: 500">(11) 2151-1233</a> ou pelo <strong style="font-weight: 500">whatsapp</strong> clicando no botão abaixo.</p>'
  },
  {
    icon: <CalendarIcon />,
    text: 'Agende todos os exames para o mesmo dia da realização do seu check-up.'
  }
];

type CallCenterModalProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const CallCenterModal = ({ visible, onClose }: CallCenterModalProps) => {
  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton={true}
      headTitle="Exames complementares"
      childrenFooterTransparent={
        <Button
          title="Enviar mensagem"
          onClick={() => {
            window.open('https://wa.me/551121511233');
          }}
          iconLeft={<WhatsappWhiteSM />}
        />
      }
    >
      <S.Container>
        <WarningIcon />
        <h3 className="title">Encaminhe os pedidos dos seus exames</h3>
        <div className="breadcrumb">
          {infos.map((item, index) => (
            <div className="row" key={index}>
              <div className="line-base">
                <div className="line" />
                {item.icon}
              </div>
              <p className="info" dangerouslySetInnerHTML={{ __html: item.text }} />
            </div>
          ))}
        </div>
      </S.Container>
    </ContainerModal>
  );
};
